import {Injectable} from '@angular/core';
import {Service, ServiceBasic} from "@shared/api/models/query/service.model";
import {GetService} from "@shared/api/services/get.service";

@Injectable({
    providedIn: 'root'
})
export class ServicesService extends GetService<ServiceBasic, Service> {

    protected override get domainEntity() {
        return 'services';
    };
}
